export default __webpack_public_path__ + "static/media/Logo.a2a33c29.png";